// A selected point belongs to the current chart data/geometry. Clear selection
// before an update: Chart.js 3 can otherwise replay a stale point after zoom
// detail replaces the dataset and a mobile resize moves the pointer outside it.
function dismiss(chart) {
  if (!chart.getActiveElements().length && !chart.tooltip?.getActiveElements().length) return false;
  chart.setActiveElements([]);
  chart.tooltip?.setActiveElements([], { x: 0, y: 0 });
  return true;
}

const listeners = new WeakMap();

const historyTooltip = {
  id: 'historyTooltip',
  beforeUpdate(chart) { dismiss(chart); },
  afterInit(chart) {
    const document = chart.canvas.ownerDocument;
    const outside = (event) => {
      if (event.target !== chart.canvas && dismiss(chart)) chart.draw();
    };
    document.addEventListener('pointerdown', outside, true);
    listeners.set(chart, () => document.removeEventListener('pointerdown', outside, true));
  },
  afterDestroy(chart) {
    listeners.get(chart)?.();
    listeners.delete(chart);
  }
};

export default historyTooltip;
